"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getUUID = void 0;

var _uuid = require("uuid");

var getUUID = function getUUID() {
  var idFront = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var prefix = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'idPeticion';
  var equalSignal = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
  var v1options = {
    node: [0x01, 0x23, 0x45, 0x67, 0x89, 0xab],
    clockseq: 0x1234,
    msecs: new Date().getTime(),
    nsecs: 5678
  };
  var uuid = (0, _uuid.v1)(v1options);
  uuid = uuid.replace(/-/g, '');
  uuid = uuid.toUpperCase();
  var res = "".concat(prefix).concat(equalSignal ? '=' : '').concat(idFront).concat(uuid);
  return res;
};

exports.getUUID = getUUID;

//# sourceMappingURL=index.js.map